export default __webpack_public_path__ + "static/media/how_it_work_image.2b4a8a56.png";